import script from "./ImageItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageItem.vue?vue&type=script&lang=ts&setup=true"

import "./ImageItem.vue?vue&type=style&index=0&id=7c2c556a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2c556a"]])

export default __exports__